import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FluencyCTA = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container mx-auto px-4">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-foreground text-background px-8 py-16 md:p-20 text-center">
          <div className="relative">
            <h2 className="font-display font-bold text-4xl md:text-6xl max-w-3xl mx-auto leading-tight">
              {t("home.cta.titleLead")}{" "}
              <span className="text-primary">
                {t("home.cta.titleHighlight")}
              </span>
            </h2>
            <p className="mt-5 text-lg text-background/70 max-w-xl mx-auto">
              {t("home.cta.subtitle")}
            </p>
            <div className="mt-8 flex justify-center">
              <Button variant="default" size="lg" asChild>
                <Link to="/signup">
                  {t("home.cta.findTutor")}
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FluencyCTA;
